export function calculateDuration(duration) {
    var remainingSeconds = duration % 3600;
    var hours = (duration - seconds) / 3600;
    hours = hours || 0;

    var seconds = remainingSeconds % 60;
    seconds = seconds || 0;

    var minutes = (remainingSeconds - seconds) / 60;
    minutes = minutes || 0;

    var result = minutes.toString() + 'm ' + seconds.toString() + 's';
    if (hours > 0) return hours.toString() + 'h ' + result;
    else return result;
}

export function padNumber(number) {
    number = number.toString();
    if (number.length == 1) number = '0' + number.toString();
    return number;
}


/** WEBPACK FOOTER **
 ** ./client/util.js
 **/